import Arrivals, { type Arrival } from 'services/Arrivals';

const CONSENT_EVENTS = ['CookiebotOnLoad', 'CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'] as const;

let pendingArrival: Arrival | null = null;

const replayOnceGranted = () => {
  if (pendingArrival && window.Cookiebot?.consent.marketing) {
    Arrivals.replay(pendingArrival);
    pendingArrival = null;
  }
};

/** Replays this page view's arrival once Cookiebot grants Marketing Consent, unless its request already carried a decision. */
export const startArrivalReplay = () => {
  // A request never carries the fragment, so neither does its replay
  pendingArrival = window.requestCarriedConsentDecision ? null : { referrer: document.referrer, url: window.location.href.split('#')[0] };
  CONSENT_EVENTS.forEach((event) => window.addEventListener(event, replayOnceGranted));
  replayOnceGranted();
};
